import { BrowserEntrypoint } from '../embed/pages/BrowserEntrypoint';
import { API_BASE } from '../lib/chatApi';
import { useNavigate } from 'react-router-dom';
import { useStore } from '../context/StoreContext';

export default function BrowserEntry() {
  const navigate = useNavigate();
  const { storeId } = useStore();
  return (
    <div className="w-full h-screen">
      <BrowserEntrypoint
        storeId={storeId}
        apiBase={API_BASE}
        onNavigateToBrowser={(q) => navigate(`/browser?q=${encodeURIComponent(q || '')}`)}
        onClose={() => navigate('/')}
      />
    </div>
  );
}


